import {ProfileEditAjaxEndPoints} from '../../../../shared/scripts/profile/ProfileEditAjaxEndPoints'
import {UIProfileUsernameController} from '../../../../shared/scripts/ui_html/header/UIProfileUsernameController'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {TranslationObject} from '@colonist/i18n'
import {UIPopupController} from '../../../../shared/scripts/ui_popup/UIPopupController'

export class UIWProfileUsernameController extends UIProfileUsernameController {
    // eslint-disable-next-line class-methods-use-this
    async updateUsername(newUsername: string, shouldPurchaseIfNoAttemptsLeft: boolean = false) {
        const success = await ProfileEditAjaxEndPoints.updateUsername(newUsername, shouldPurchaseIfNoAttemptsLeft)
        if(!success) return
        UIWProfileUsernameController.showSuccessPopup(newUsername)
    }

    private static showSuccessPopup(newUsername: string) {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return

        const title: TranslationObject = {key: 'strings:storePage.success.success'}
        const body: TranslationObject = {
            key: 'strings:homePage.header.changeUsername.successDiscord',
            options: {
                username: newUsername,
            },
        }
        UIPopupController.createSimplePopup(title, body)
    }
}
